import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Ban, MicOff, MessageSquareOff, EyeOff } from 'lucide-react';

interface PunishmentMenuProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSelect: (action: string, reason: string) => void;
}

export const PunishmentMenu = ({ open, onOpenChange, onSelect }: PunishmentMenuProps) => {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent side="bottom" className="h-[80vh] rounded-t-3xl border-t border-pop/50 bg-surface backdrop-blur-xl">
                <SheetHeader className="mb-6">
                    <SheetTitle className="text-center text-pop font-display text-xl uppercase tracking-widest">
                        処罰の執行
                    </SheetTitle>
                </SheetHeader>

                <ScrollArea className="h-full pb-20">
                    <div className="space-y-6 px-1">
                        {/* Quick Presets */}
                        <section>
                            <h4 className="text-xs text-muted-foreground uppercase tracking-wider mb-3 pl-2">一時的な制限</h4>
                            <div className="grid grid-cols-2 gap-3">
                                <Button variant="outline" className="h-20 flex flex-col gap-2 border-ink/15 hover:border-yellow-500 hover:text-yellow-500" onClick={() => onSelect('restrict_24h', 'WARN_TEMP')}>
                                    <MicOff size={24} />
                                    <span>24時間ミュート</span>
                                </Button>
                                <Button variant="outline" className="h-20 flex flex-col gap-2 border-ink/15 hover:border-yellow-500 hover:text-yellow-500" onClick={() => onSelect('restrict_post', 'WARN_SPAM')}>
                                    <MessageSquareOff size={24} />
                                    <span>活動制限</span>
                                </Button>
                            </div>
                        </section>

                        {/* Shadow Realm */}
                        <section>
                            <h4 className="text-xs text-muted-foreground uppercase tracking-wider mb-3 pl-2">シャドウ操作</h4>
                            <Button variant="ghost" className="w-full justify-between h-16 bg-purple-900/20 border border-purple-500/20 hover:bg-purple-900/40 text-purple-400 group" onClick={() => onSelect('shadow_ban', 'SHADOW_QUAL')}>
                                <div className="flex items-center gap-4">
                                    <EyeOff size={24} />
                                    <div className="text-left">
                                        <div className="font-bold group-hover:text-purple-300">シャドウバン</div>
                                        <div className="text-xs opacity-60">ユーザーには通知されず、他者から見えなくなります</div>
                                    </div>
                                </div>
                                <div className="w-2 h-2 rounded-full bg-purple-500 animate-pulse" />
                            </Button>
                        </section>

                        {/* Nuke Options */}
                        <section>
                            <h4 className="text-xs text-muted-foreground uppercase tracking-wider mb-3 pl-2">恒久的な処置</h4>
                            <Button variant="destructive" className="w-full justify-start h-16 gap-4 text-lg font-bold" onClick={() => onSelect('ban', 'VIOLATION_TOS')}>
                                <Ban size={24} />
                                アカウント停止 (BAN)
                            </Button>
                        </section>
                    </div>
                </ScrollArea>
            </SheetContent>
        </Sheet>
    );
};
